(function (Drupal) {
  Drupal.behaviors.menuHasChildren = {
    attach: function (context) {
      // Elements
      const menuLinks = document.querySelector(
        ".ccc-header__navigation nav > ul"
      );

      // Loop through each menu item and check if it has children, apply class if true
      for (let i = 0; i < menuLinks.children.length; i++) {
        if (menuLinks.children[i].children.length >= 2) {
          // Convert HTML-collection to array
          menuLinkChildren = Array.from(menuLinks.children[i].children);

          // Loop through each list item and check if it contains another <ul>
          // add "has-children" class if true
          menuLinkChildren.forEach((menuLinkChild) => {
            if (menuLinkChild.nodeName === "UL") {
              menuLinks.children[i].classList.add("has-children");
            }
          });
        }
      }
    },
  };
})(Drupal);